import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PAYMENT_BASE_URL, APP_BASE_URL, getPaymentUrl } from '@/config/urls';

interface DomainRestrictedRouteProps {
  children: React.ReactNode;
  allowedOnPaymentDomain?: boolean;
  allowedOnAppDomain?: boolean;
}

const DomainRestrictedRoute: React.FC<DomainRestrictedRouteProps> = ({
  children,
  allowedOnPaymentDomain = false,
  allowedOnAppDomain = true
}) => {
  const location = useLocation();
  const isPaymentDomain = window.location.hostname === new URL(PAYMENT_BASE_URL).hostname;
  
  // For localhost development, treat it as both domains are allowed
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isAppDomain = !isPaymentDomain; 
  
  if (isPaymentDomain && !allowedOnPaymentDomain && !isLocalhost) {
    // Allow bundle routes on any domain (they are public payment pages)
    if (location.pathname.startsWith('/bundle/') || location.pathname.startsWith('/offer/')) {
      return <>{children}</>;
    }
    return <Navigate to="/" replace />;
  }
  
  if (isAppDomain && !allowedOnAppDomain && !isLocalhost) {
    // Allow bundle routes on any domain (they are public payment pages)
    if (location.pathname.startsWith('/bundle/') || location.pathname.startsWith('/offer/')) {
      return <>{children}</>;
    }
      
    if (location.pathname.match(/^\/[a-zA-Z0-9-_]+$/) && !location.pathname.match(/^\/(auth|dashboard|create|settings|invoice|offer|terms|privacy)($|\/)/)) {
      const productId = location.pathname.substring(1); 
      const paymentUrl = getPaymentUrl(productId);
      window.location.href = paymentUrl;
      return null;
    }
    
    if (location.pathname.startsWith('/pay/')) {
      const productId = location.pathname.split('/pay/')[1];
      const paymentUrl = getPaymentUrl(productId);
      window.location.href = paymentUrl;
      return null;
    }
    
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default DomainRestrictedRoute;
